import { setSort } from "../EmployeeSlice";
import { Dispatch } from "redux";
import { EmployeeSortEnum } from "../../../common/enums/EmployeeSortEnum";

interface Props {
    dispatch: Dispatch;
    sort: {
        sortName: string;
        isSorted: boolean;
    };
}

export const handleEmployeeSort = (props: Props) => () => {
    const { dispatch, sort } = props;

    let nextSortName = "";
    const nextIsSorted = !sort.isSorted;

    switch (sort.sortName) {
        case EmployeeSortEnum.NAME:
            nextSortName = sort.isSorted
                ? EmployeeSortEnum.NAME_ASC
                : EmployeeSortEnum.NAME_DESC;
            break;
        case EmployeeSortEnum.FUNCTION_GROUP:
            nextSortName = sort.isSorted
                ? EmployeeSortEnum.FUNCTION_GROUP_ASC
                : EmployeeSortEnum.FUNCTION_GROUP_DESC;
            break;
        case EmployeeSortEnum.ROLE:
            nextSortName = sort.isSorted
                ? EmployeeSortEnum.ROLE_ASC
                : EmployeeSortEnum.ROLE_DESC;
            break;
        case EmployeeSortEnum.ACHIEVED_CERTIFICATES:
            nextSortName = sort.isSorted
                ? EmployeeSortEnum.ACHIEVED_CERTIFICATES_ASC
                : EmployeeSortEnum.ACHIEVED_CERTIFICATES_DESC;
            break;
        case EmployeeSortEnum.MISSING_CERTIFICATES:
            nextSortName = sort.isSorted
                ? EmployeeSortEnum.MISSING_CERTIFICATES_ASC
                : EmployeeSortEnum.MISSING_CERTIFICATES_DESC;
            break;
        case EmployeeSortEnum.EXPIRING_CERTIFICATES:
            nextSortName = sort.isSorted
                ? EmployeeSortEnum.EXPIRING_CERTIFICATES_ASC
                : EmployeeSortEnum.EXPIRING_CERTIFICATES_DESC;
            break;
        default:
            return;
    }

    dispatch(
        setSort({
            sortName: nextSortName,
            isSorted: nextIsSorted,
        }),
    );
};
